import { isDebug } from '../../mixins/is-debug';

const emptyTimeRegistrations = {
    0: null,
    1: null,
    2: null,
    3: null,
};

export default {
    namespaced: true,
    state: {
        sessionKeys: {},
        apiCredentials: {
            token: null,
            refreshToken: null,
        },
        rights: null,
        userId: null,
        name: null,
        userName: null,
        userLocation: null,
        userLocationDate: null,
        tikklok: {
            title: {
                //#tikkloktitle
                show: true,
                text: '',
            },
            breakTitle: {
                //.breaktitle
                show: true,
                text: '',
            },
            showActions: true, //#tikklokmenuactions
            showStartWorkDay: true, //#startWerkdag
            showStopWorkDay: true, //#stopWerkdag
            showStartBreak: true, //#startPauze
            showStopBreak: true, //#stopPauze
            showStartSmokingBreak: true, //#startRookPauze
            showStopSmokingBreak: true, //#stopRookPauze
            totalSmokeTime: 0,
            timeRegistrations: { ...emptyTimeRegistrations },
        },
        qrScanner: {
            cameraTypes: [],
        },
    },
    mutations: {
        setQrScannerCameraType(state, { cameraKey, cameraType }) {
            const dict = { ...state.qrScanner.cameraTypes };
            dict[cameraKey] = cameraType;
            state.qrScanner.cameraTypes = dict;
        },
        setTimeRegistrations(state, timeRegistrations) {
            const result = { ...emptyTimeRegistrations };

            for (let i = 0; i < timeRegistrations.length; i++) {
                if (timeRegistrations[i]) {
                    result[i] = timeRegistrations[i].time;
                }
            }

            state.tikklok.timeRegistrations = result;
        },
        setApiCredentials(state, { token, refreshToken }) {
            state.apiCredentials = {
                token,
                refreshToken,
            };
        },
        revokeApiCredentials(state) {
            state.apiCredentials = {
                token: null,
                refreshToken: null,
            };
        },
        setTotalSmokeTime(state, totalSmokeTime) {
            state.tikklok.totalSmokeTime = totalSmokeTime;
        },
        setTikklokTitle(state, title) {
            state.tikklok.title.text = title;
        },
        showTikklokTitle(state) {
            state.tikklok.title.show = true;
        },
        hideTikklokTitle(state) {
            state.tikklok.title.show = false;
        },
        setTikklokBreakTitle(state, title) {
            state.tikklok.breakTitle.text = title;
        },
        showTikklokBreakTitle(state) {
            state.tikklok.breakTitle.show = true;
        },
        hideTikklokBreakTitle(state) {
            state.tikklok.breakTitle.show = false;
        },
        showActions(state) {
            if (isDebug()) {
                console.trace('currentUser/showActions');
            }
            state.tikklok.showActions = true;
        },
        hideActions(state) {
            if (isDebug()) {
                console.trace('currentUser/hideActions');
            }
            state.tikklok.showActions = false;
        },
        initWorkDayBreakState(state) {
            if (isDebug()) {
                console.trace('currentUser/initWorkDayBreakState');
            }
            state.tikklok.showStartWorkDay = false;
            state.tikklok.showStopWorkDay = false;
            state.tikklok.showStartBreak = false;
            state.tikklok.showStopBreak = false;
        },
        showStartWorkDayState(state) {
            if (isDebug()) {
                console.trace('currentUser/showStartWorkDayState');
            }
            state.tikklok.showStartWorkDay = true;
            state.tikklok.showStopWorkDay = false;
            state.tikklok.showStartBreak = false;
            state.tikklok.showStopBreak = false;
        },
        showStopWorkDayState(state) {
            if (isDebug()) {
                console.trace('currentUser/showStopWorkDayState');
            }
            state.tikklok.showStartWorkDay = false;
            state.tikklok.showStopWorkDay = true;
            state.tikklok.showStartBreak = false;
            state.tikklok.showStopBreak = false;
        },
        showStartBreakState(state) {
            if (isDebug()) {
                console.trace('currentUser/showStartBreakState');
            }
            state.tikklok.showStartWorkDay = false;
            state.tikklok.showStopWorkDay = false;
            state.tikklok.showStartBreak = true;
            state.tikklok.showStopBreak = false;
        },
        showStopBreakState(state) {
            if (isDebug()) {
                console.trace('currentUser/showStopBreakState');
            }
            state.tikklok.showStartWorkDay = false;
            state.tikklok.showStopWorkDay = false;
            state.tikklok.showStartBreak = false;
            state.tikklok.showStopBreak = true;
        },
        initSmokingBreakAction(state) {
            if (isDebug()) {
                console.trace('currentUser/initSmokingBreakAction');
            }
            state.tikklok.showStartSmokingBreak = false;
            state.tikklok.showStopSmokingBreak = false;
        },
        showStartSmokingBreakAction(state) {
            if (isDebug()) {
                console.trace('currentUser/showStartSmokingBreakAction');
            }
            state.tikklok.showStartSmokingBreak = true;
            state.tikklok.showStopSmokingBreak = false;
        },
        showStopSmokingBreakAction(state) {
            if (isDebug()) {
                console.trace('currentUser/showStopSmokingBreakAction');
            }
            state.tikklok.showStartSmokingBreak = false;
            state.tikklok.showStopSmokingBreak = true;
        },
        setSessionKey(state, { key, environment }) {
            let keys = state.sessionKeys;

            if (typeof state.sessionKeys !== 'object') {
                keys = {};
            }

            keys[environment] = key;

            state.sessionKeys = keys;
        },
        setRights(state, title) {
            state.rights = title;
        },
        setUserId(state, title) {
            state.userId = title;
        },
        setName(state, title) {
            state.name = title;
        },
        setUserName(state, title) {
            state.userName = title;
        },
        setUserLocation(state, title) {
            state.userLocation = title;
            const today = new Date();
            state.userLocationDate =
                today.getFullYear() +
                '-' +
                (today.getMonth() + 1) +
                '-' +
                today.getDate();
        },
        setUserLocationDateCurrent(state) {
            const today = new Date();
            state.userLocationDate =
                today.getFullYear() +
                '-' +
                (today.getMonth() + 1) +
                '-' +
                today.getDate();
        },
        setUserLocationDate(state, date) {
            state.userLocationDate = date;
        },
        unsetUserLocation(state) {
            state.userLocation = null;
            state.userLocationDate = null;
        },
    },
    getters: {
        getQrScannerCameraType: (state) => (cameraKey) => {
            return state.qrScanner.cameraTypes[cameraKey] || null;
        },
        getShowTikklokBreakTitle(state) {
            return state.tikklok.breakTitle.show;
        },
        getTimeRegistration: (state) => (index) => {
            return state.tikklok.timeRegistrations[index] || null;
        },
        getTotalSmokeTime(state) {
            return state.tikklok.totalSmokeTime;
        },
        getTikklok(state) {
            return state.tikklok;
        },
        getApiCredentials(state) {
            return state.apiCredentials;
        },
        getSessionKey: (state) => (environment) => {
            if (!environment) {
                return;
            }

            return state.sessionKeys[environment];
        },
        getRights(state) {
            return state.rights;
        },
        hasRight: (state) => (right) => {
            return state.rights.includes(right);
        },
        isValidLogin(state) {
            if (
                !state.userName ||
                Object.keys(state.sessionKeys).some(
                    (key) => !key || key.length === 0
                )
            ) {
                console.error('Not logged in properly');

                return false;
            }

            return true;
        },
        getUserId(state) {
            return state.userId;
        },
        getName(state) {
            return state.name;
        },
        getUserName(state) {
            return state.userName;
        },
        getUserLocation(state) {
            return state.userLocation;
        },
        getUserLocationDate(state) {
            return state.userLocationDate;
        },
    },
};
